import { EndCardsType } from "@/types/OptionType";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNavigation,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import { EndCard } from "../../components/EventCard/EventCard";
import { Section } from "../../components/Section/Section";
import PostCard from "../../components/PostCard/PostCard";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { PostsSliderOptionsType } from "@/types/ModuleOptionsType";
import { Modul_Post_Slider } from "../../wp/types/acf-module-types";
import { PostSliderData } from "../../getData/getIndexedPostSliderData";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { columnSize } from "@/utils/layout/columnSize";
import { Headline } from "@/components/Headline/Headline";
import { FadeInUp } from "../../components/Animation/ScrollAnimation";

export type PostsSliderModuleType = Modul_Post_Slider;

interface PostsSliderProps {
  data: PostsSliderModuleType;
  postsSliderOptions: PostsSliderOptionsType;
  postSliderData: PostSliderData;
  endCardData: EndCardsType | undefined;
}

function PostSliderModule({
  data,
  postsSliderOptions,
  postSliderData,
  endCardData,
}: PostsSliderProps) {
  const { headline_html_tag, headline, overline, subline } = data.slider;
  const {
    background_color_class,
    section_margin_class,
    section_padding_class,
    headline_text_align_class,
    module_width,
    grid_columns,
  } = data.layout;
  const {
    // button_type,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_overline_subline,
    slider_options: {
      slider_navigation,
      has_autoplay,
      cards_slider_options: { end_card, show_end_card },
    },
    media_format,
    columns,
  } = postsSliderOptions ?? {};
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  const sliderPosts = postSliderData.posts;

  const { getLabel } = useGlobalContext();

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }
  return (
    <Section
      className={`post-slider ${background_color_class} ${section_margin_class} ${section_padding_class}`}
      disableColumns={module_width !== "narrow-frame"}
      columnsClassName="is-centered is-multiline"
      // frameless={module_width === "frameless"}
    >
      <div
        className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
      >
        {headline && (
          <FadeInUp>
            <Headline
              headline_html_tag={headline_html_tag}
              headline={headline}
              extraClass={`${headline_text_align_class}`}
              overline={showOverline ? overline : ""}
              subline={showSubline ? subline : ""}
              wrapInSection={module_width === "frameless"}
              disableAnimation
            />
          </FadeInUp>
        )}
        <FadeInUp>
          <Carousel autoplay={has_autoplay} align={"start"}>
            <CarouselContent
              outerPadding="16px"
              spacing="32px"
              overflowVisible={module_width === "frameless"}
            >
              {sliderPosts.map((post, i) => {
                return (
                  <CarouselItem
                    key={i}
                    itemWidth={{
                      mobile: "100%",
                      tablet: "50%",
                      ...(grid_columns === "three-cols" && {
                        desktop: "33.3333333%",
                        ultrahd: "25%",
                      }),
                    }}
                  >
                    <PostCard
                      element={post}
                      border_radius={show_border_radius}
                      box_shadow={show_box_shadow}
                      readMoreLabel={getLabel("read_more_label")}
                      showBox={show_card_box}
                      grid_columns={grid_columns}
                      media_format={media_format}
                      allCategories={postSliderData.allCategories}
                      isSlider
                    />
                  </CarouselItem>
                );
              })}
              {show_end_card && endCardData && endCardData.link && (
                <CarouselItem
                  itemWidth={{
                    mobile: "100%",
                    tablet: "50%",
                    ...(grid_columns === "three-cols" && {
                      desktop: "33.3333333%",
                      ultrahd: "25%",
                    }),
                  }}
                >
                  <EndCard
                    headlineTag={headline_html_tag}
                    show_border_radius={show_border_radius}
                    end_card={{
                      background_color: end_card.background_color,
                      button_type: end_card.button_type,
                      link: endCardData.link,
                      title: endCardData.title,
                    }}
                    show_box_shadow={show_box_shadow}
                    showBox={show_card_box}
                  />
                </CarouselItem>
              )}
            </CarouselContent>
            <CarouselNavigation type={slider_navigation} />
          </Carousel>
        </FadeInUp>
      </div>
    </Section>
  );
}
export default PostSliderModule;
